import { hooks } from '@/store.js'
import { buttonVariants } from '../ui/button.js'
import { Input } from '../ui/input.js'
import { useRef, useState } from 'react'
import { CheckIcon, Cross2Icon } from '@radix-ui/react-icons'
import { cn } from '@/lib/utils.js'
import { AnimatePresence, AnimationProps, motion } from 'framer-motion'

const animationProps: AnimationProps = {
  animate: {
    x: 0,
    opacity: 1,
  },
  exit: {
    x: -50,
    opacity: 0,
  },
  initial: {
    x: -50,
    opacity: 0,
  },
}

export function AddNew({ onAddClick }: { onAddClick?: () => void }) {
  const [status, setStatus] = useState('idle' as 'idle' | 'adding')
  const client = hooks.useClient()
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <motion.form
      className="flex items-center gap-2"
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          setStatus('idle')
        }
      }}
      onSubmit={(e) => {
        e.preventDefault()
        setStatus('idle')

        const data = new FormData(e.currentTarget)
        const value = data.get('content')

        client.habits.put({
          name: String(value || 'Untitled habbit'),
        })

        e.currentTarget.reset()
      }}
    >
      <AnimatePresence
        initial={false}
        mode="popLayout"
        onExitComplete={() => {
          console.log('exit complete')
        }}
      >
        {status === 'adding' && (
          <motion.div layout key="input" className="flex items-center gap-2" {...animationProps}>
            <Input
              ref={inputRef}
              autoFocus
              autoComplete="off"
              defaultValue=""
              placeholder="Habit name..."
              type="text"
              name="content"
              className="w-48"
            />
            <button type="submit" className={cn(buttonVariants())}>
              <CheckIcon />
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        layout
        layoutId="add-new-button"
        type="button"
        className={cn(
          buttonVariants({
            className: 'gap-2',
            variant: status === 'idle' ? 'default' : 'destructive',
          }),
        )}
        onClick={() => {
          if (status === 'idle') {
            onAddClick?.()
            setStatus('adding')
            setTimeout(() => {
              inputRef.current?.focus()
            })
          } else {
            setStatus('idle')
          }
        }}
      >
        {status === 'adding' ? '' : 'Add habbit'}
        {status === 'adding' && <Cross2Icon />}
      </motion.button>
    </motion.form>
  )
}
